// Get element by id "id-reviews"
var reviewsElement = document.getElementById('id-reviews');
var reviews = document.getElementsByClassName('review-card-side');

// Get length of reviews
var reviewsLength = reviews.length;
var review_idx = 0;


var buttons = reviewsElement.getElementsByClassName('review-refresh-button');
// add event listeners to button and link them to cycleReview
for (var i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener('click', function() {
    cycleReview(review_idx);
  });
}

for (var i = 0; i < reviewsLength; i++) {
  reviews[i].addEventListener("animationend", function() {
    reviewAnimationEnd(this);
  });
}

function reviewAnimationEnd(object) {
  if (object.classList.contains("review-animation-front")) {
    object.classList.remove("review-animation-front");
    object.classList.remove("front");
    object.classList.add("inqueue");
    object.classList.remove("bg-review-primary");
    object.classList.remove("bg-review-secondary");
    review_idx++;
  }
  if (object.classList.contains("review-animation-back")) {
    object.classList.remove("review-animation-back");
    object.classList.remove("back");
    object.classList.add("front");
  }

}


// Get the i'th review
function getReview(i) {
  return reviews[i];
}

function getIndex(i) {
  return i % reviewsLength;

}

// Set the i'th review to display block
function cycleReview(i) {
  active_idx = getIndex(i);
  next_idx = getIndex(i+1);

  active_review = getReview(active_idx);
  next_review = getReview(next_idx);

  if(active_review.classList.contains("review-animation-front") || active_review.classList.contains("review-animation-back")) {
    return;
  }

  if (active_review.classList.contains("bg-review-primary")) {
    next_review.classList.remove("bg-review-primary");
    next_review.classList.add("bg-review-secondary");
  } else {
    next_review.classList.remove("bg-review-secondary");
    next_review.classList.add("bg-review-primary");
  }

  next_review.classList.remove("inqueue")
  next_review.classList.add("back")
  active_review.classList.add("review-animation-front");
  next_review.classList.add("review-animation-back");

}








